module.exports = __webpack_public_path__ + "img/medium-icon.d50efb18.png";